import { X } from "lucide-react";

const FilterPill = ({ label, onRemove }) => {
  return (
    <span className="filter-pill inline-flex items-center bg-blue-100 text-blue-800 text-sm rounded-full px-3 py-1 mr-2 mb-2">
      {label}
      <button onClick={onRemove} className="ml-2 focus:outline-none">
        <X size={14} />
      </button>
    </span>
  );
};

export default FilterPill;
